const getDefaultState = () => ({
  seasons: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  suppliers: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  salesTypes: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  lessonTypes: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  skiTypes: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  season: {
    itemsError: undefined,
    itemsLoading: false,
    saveError: undefined,
    saveLoading: false,
    id: undefined,
    twentySupplierId: undefined,
    name: undefined,
    arrivalFrom: undefined,
    arrivalTo: undefined,
    active: true,
    webActive: true,
    commissionRatio: 0,
    contributionRatio: 0,
    bookDaysBeforeArrival: 0,
    priceAdjustmentValue: 1,
    netOrGross: 'gross',
    salesRule: 'booking',
    informationText: null,
    keyCardPaymentType: 'mandatory',
    keyCard: undefined,
    supplier: undefined,
    newSeasonItem: {
      itemsError: undefined,
      itemsLoading: false,
      saveError: undefined,
      saveLoading: false,
      id: undefined,
      twentySupplierId: undefined,
      name: undefined,
      arrivalFrom: undefined,
      arrivalTo: undefined,
      active: true,
      webActive: true,
      commissionRatio: 0,
      contributionRatio: 0,
      bookDaysBeforeArrival: 0,
      priceAdjustmentValue: 1,
      netOrGross: 'gross',
      salesRule: 'booking',
      informationText: null,
      supplier: undefined,
    },
    personCategories: {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
      saveLoading: false,
      saveError: undefined,
      newItem: {
        id: undefined,
        skiSchoolSeasonId: undefined,
        name: undefined,
        externalName: undefined,
        ageFrom: undefined,
        ageTo: undefined,
      },
    },
    levels: {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
      saveLoading: false,
      saveError: undefined,
      newItem: {
        id: undefined,
        skiSchoolSeasonId: undefined,
        name: undefined,
        externalName: undefined,
        priority: 1,
      },
    },
    prices: {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
      saveLoading: false,
      saveError: undefined,
      activePriceId: undefined,
      newPriceItem: {
        id: undefined,
        skiSchoolSeasonId: undefined,
        skiSchoolSeasonPersonCategoryId: undefined,
        skiSchoolLessonTypeId: undefined,
        skiSchoolSkiTypeId: undefined,
        numberOfPersons: undefined,
        days: undefined,
        durationMinutes: undefined,
        price: undefined,
        commissionRatio: undefined,
        contributionRatio: undefined,
        webActive: true,
      },
    },
    skiAreas: {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
      ids: [],
    },
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/ski/school/defaultState.js